<template>
    <!-- 팝업 -->

    <div class="pop_up_layer" style="display: block" @click="closeModal"></div>
    <div class="pop_up applicant_chk" style="display: block; max-width: 1600px">
        <button class="close_btn icon_wrap" @click="closeModal">
            <img src="img/close.png" alt="닫기" />
        </button>

        <div class="pop_tit">
            <p>{{ state.data.title }}</p>
        </div>
        <div class="date_wrap">
            <span class="state_tage" :class="[state.data.state === 3 ? 'finish' : '']">{{ state.data.state === 3 ? "종료" : "모집중" }}</span>
            <div class="collection_period" v-if="state.data.recruitStartDate && state.data.recruitEndDate">
                <span>
                    <img src="img/time_icon.png" alt="" />
                    모집기간
                </span>
                <span>{{ CommonUtils.dateFormat(new Date(state.data.recruitStartDate), ".", false) }}</span>
                <em>-</em>
                <span>{{ CommonUtils.dateFormat(new Date(state.data.recruitEndDate), ".", false) }}</span>
            </div>
            <div class="end_point" v-if="state.data.applyDate !== null">
                <span>
                    <img src="img/time_icon.png" alt="" />
                    신청종료일
                </span>
                <span>{{ state.data.applyDate !== null ? CommonUtils.dateFormat(new Date(state.data.applyDate), ".", false) : "" }}</span>
            </div>
            <div class="activity_duration" v-if="state.data.activeStartDate && state.data.activeEndDate">
                <span>
                    <img src="img/cal_icon_blue.png" alt="" />
                    활동기간
                </span>
                <span>{{ CommonUtils.dateFormat(new Date(state.data.activeStartDate), ".", false) }}</span>
                <em>-</em>
                <span>{{ CommonUtils.dateFormat(new Date(state.data.activeEndDate), ".", false) }}</span>
            </div>
        </div>
        <div class="list_container" v-if="state.eventIdx !== props.idx">
            <div class="left">
                <div class="num_wrap">
                    <span>신청인원</span>
                    <span>{{ state.cntApply }} 명</span>
                </div>
                <button type="button" class="excel_btn icon_wrap" @click="downloadFile(false)"><img src="img/excel_icon.png" alt="" /></button>

                <div class="table_wrap custom_scroll">
                    <table style="table-layout: auto; width: 100%">
                        <colgroup>
                            <col style="min-width: 70px" />
                            <col style="min-width: 130px; width: auto" v-for="form in state.formList" />
                            <col style="min-width: 100px" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>번호</th>
                                <th style="white-space: nowrap" v-for="form in state.formList">{{ form.title }}</th>
                                <th>신청일</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="state.cntApply > 0">
                                <tr v-for="(item, idx) in state.applyList" :key="item.idx">
                                    <td>{{ (state.page - 1) * state.size + (idx + 1) }}</td>
                                    <td style="white-space: pre-line" v-for="form in item.formList" v-html="answerFormat(form)"></td>
                                    <td>{{ CommonUtils.dateFormatYY(new Date(item.createDate), ".") }}</td>
                                </tr>
                            </template>
                            <tr v-else>
                                <td :colspan="2 + (state.formList.length > 0 ? state.formList.length : 0)">
                                    <div class="tb_subject" style="display: block; text-align: center; width: 100%">신청 인원이 없습니다.</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <PageBtn :currentPage="state.applyPage" :perPage="state.size" :totalLength="state.cntApply" @onPaging="applyPaging"></PageBtn>
            </div>
        </div>
        <div class="list_container _flex" v-else>
            <div class="left">
                <div class="num_wrap">
                    <span>신청인원</span>
                    <span>{{ state.cntApply }} 명</span>
                </div>
                <button type="button" class="excel_btn icon_wrap" @click="downloadFile(false)"><img src="img/excel_icon.png" alt="" /></button>

                <div class="list_th">
                    <span class="_num" style="width: 10%">번호</span>
                    <span class="_name" style="width: 20%">이름</span>
                    <span class="_name" style="width: 30%">이메일</span>
                    <span class="_ph" style="width: 30%">전화번호</span>
                    <span class="_ph" style="width: 15%">연령대</span>
                    <span class="_date" style="width: 40%">당신의 관심이 변화를 만듭니다.</span>
                    <span class="_date" style="width: 40%">‘그들’이 아닌 ‘우리’의 문제입니다.</span>
                    <span class="_date" style="width: 40%">존중과 인권을 이야기합니다.</span>
                    <span class="_date" style="width: 20%">신청일</span>
                </div>
                <div class="list_wrap custom_scroll light_gray">
                    <div class="list_td" v-for="(item, idx) in state.applyList" :key="item.idx">
                        <span class="_num" style="width: 10%">{{ (state.applyPage - 1) * state.size + (idx + 1) }}</span>
                        <span class="_name" style="width: 20%">{{ item.name }}</span>
                        <span class="_name" style="width: 30%; text-align: left">{{ item.email }}</span>
                        <span class="_ph" style="width: 30%">{{ CommonUtils.convertPhoneNumReal(item.phoneNum) }}</span>
                        <span class="_ph" style="width: 15%" v-if="item.age === 1">10대</span>
                        <span class="_ph" style="width: 15%" v-else-if="item.age === 2">20대</span>
                        <span class="_ph" style="width: 15%" v-else-if="item.age === 3">30대</span>
                        <span class="_ph" style="width: 15%" v-else-if="item.age === 4">40대</span>
                        <span class="_ph" style="width: 15%" v-else-if="item.age === 5">50대</span>
                        <span class="_ph" style="width: 15%" v-else-if="item.age === 6">60대</span>
                        <span class="_ph" style="width: 15%" v-else-if="item.age === 7">70대 이상</span>
                        <span class="checkbox_wrap2" style="width: 40%">
                            <label :for="'chk_step1_0'" @click.stop>
                                <input type="checkbox" :id="'chk_step1_0'" v-model="item.step1" :value="0" disabled />
                            </label>
                            <label :for="'chk_step1_1'" @click.stop>
                                <input type="checkbox" :id="'chk_step1_1'" v-model="item.step1" :value="1" disabled />
                            </label>
                            <label :for="'chk_step1_2'" @click.stop>
                                <input type="checkbox" :id="'chk_step1_2'" v-model="item.step1" :value="2" disabled />
                            </label>
                        </span>
                        <span class="checkbox_wrap2" style="width: 40%">
                            <label :for="'chk_step2_0'" @click.stop>
                                <input type="checkbox" :id="'chk_step2_0'" v-model="item.step2" :value="0" disabled />
                            </label>
                            <label :for="'chk_step2_1'" @click.stop>
                                <input type="checkbox" :id="'chk_step2_1'" v-model="item.step2" :value="1" disabled />
                            </label>
                            <label :for="'chk_step2_2'" @click.stop>
                                <input type="checkbox" :id="'chk_step2_2'" v-model="item.step2" :value="2" disabled />
                            </label>
                        </span>
                        <span class="checkbox_wrap2" style="width: 40%">
                            <label :for="'chk_step3_0'" @click.stop>
                                <input type="checkbox" :id="'chk_step3_0'" v-model="item.step3" :value="0" disabled />
                            </label>
                            <label :for="'chk_step3_1'" @click.stop>
                                <input type="checkbox" :id="'chk_step3_1'" v-model="item.step3" :value="1" disabled />
                            </label>
                            <label :for="'chk_step3_2'" @click.stop>
                                <input type="checkbox" :id="'chk_step3_2'" v-model="item.step3" :value="2" disabled />
                            </label>
                        </span>
                        <span class="_date" style="width: 20%">{{ CommonUtils.dateFormatYY(new Date(item.createDate), ".") }}</span>
                    </div>
                </div>
                <PageBtn :currentPage="state.applyPage" :perPage="state.size" :totalLength="state.cntApply" @onPaging="applyPaging"></PageBtn>
            </div>
        </div>
        <div class="memo_wrap">
            <div class="cntWin_memo" v-if="state.eventIdx !== props.idx">
                <div>
                    <label for="cntWin">당첨인원</label>
                    <input id="cntWin" type="number" placeholder="당첨인원을 입력해주세요." v-model="state.data.cntWin" />
                </div>
                <div>
                    <label for="memo">메모</label>
                    <textarea id="memo" placeholder="메모" class="custom_scroll light_gray" v-model="state.data.memo"></textarea>
                </div>
            </div>
            <div class="step_content" v-else>
                <div>
                    <h1>당신의 관심이 변화를 만듭니다.</h1>
                    <p class="checkbox_wrap2">
                        <label @click.stop>
                            <input type="checkbox" disabled />
                        </label>
                        외면도, 무관심도, 침묵도 성매매 카르텔입니다.
                    </p>
                    <p class="checkbox_wrap2">
                        <label @click.stop>
                            <input type="checkbox" disabled />
                        </label>
                        ANTI 성매매에 끊임없이 관심을 가집시다.
                    </p>
                    <p class="checkbox_wrap2">
                        <label @click.stop>
                            <input type="checkbox" disabled />
                        </label>
                        성매매는 사회의 병적인 존재다. 이제는 변화해야 한다. 제발...
                    </p>
                </div>
                <div>
                    <h1>‘그들’이 아닌 ‘우리’의 문제입니다.</h1>
                    <p class="checkbox_wrap2">
                        <label @click.stop>
                            <input type="checkbox" disabled />
                        </label>
                        성매매 문제는 남의 일이 아닙니다. 우리가 반드시 해결해야 하므로 함께 해 주십시오
                    </p>
                    <p class="checkbox_wrap2">
                        <label @click.stop>
                            <input type="checkbox" disabled />
                        </label>
                        '그들'(성매매 여성)만의 문제가 아닌 '우리'(여성 그리고 모두)의 문제입니다.
                    </p>
                    <p class="checkbox_wrap2">
                        <label @click.stop>
                            <input type="checkbox" disabled />
                        </label>
                        성매매는 '불법', 성구매자는 '전과자'입니다.
                    </p>
                </div>
                <div>
                    <h1>존중과 인권을 이야기합니다.</h1>
                    <p class="checkbox_wrap2">
                        <label @click.stop>
                            <input type="checkbox" disabled />
                        </label>
                        성매매는 인권의 문제! 성매매라고 쓰고 성착취(성폭력)라고 읽는다.
                    </p>
                    <p class="checkbox_wrap2">
                        <label @click.stop>
                            <input type="checkbox" disabled />
                        </label>
                        2차 피해만큼은 하지 마십시오. 당신도 똑같은 가해자입니다.
                    </p>
                    <p class="checkbox_wrap2">
                        <label @click.stop>
                            <input type="checkbox" disabled />
                        </label>
                        성매매 없는 사회, 인간의 존중과 가치를 보여주세요.
                    </p>
                </div>
            </div>
        </div>
        <div class="btn_wrap _default _center" v-if="state.eventIdx !== props.idx">
            <button class="submit_btn w_120" @click="save">확인</button>
        </div>
    </div>
    <!-- 팝업 -->

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="state.isShowModal = false"
    ></ModalDefault>

    <AnswerModal
        v-if="state.isShowAnswer"
        :answerInfo="state.answerInfo"
        @close="state.isShowAnswer = false"
        @callback="
            state.isShowAnswer = false;
            getApplyList();
        "
    ></AnswerModal>
</template>
<script lang="ts">
    import {
        onMounted,
        reactive,
        watch,
        onUnmounted,
        CommonUtils,
        apiService,
        types,
        getMessageByCode,
        AnswerModal,
        ModalDefault,
        PageBtn,
    } from "@/BaseComponent";

    export default {
        props: {
            idx: {
                type: Number,
                default: 0,
            },
            data: {
                type: Object,
                defalut: {},
            },
        },
        emits: ["close", "save"],
        components: { AnswerModal, ModalDefault, PageBtn },
        setup(props: any, { emit }: any) {
            const state = reactive({
                eventIdx: 139,
                idx: 0 as number,
                data: {} as any,
                formList: [] as Array<types.BoardApplyFormVOForApi>,
                applyList: [] as Array<types.ResEventApplyVOForApi>,
                applyPage: 1 as number,
                cntApply: 0 as number,
                page: 1 as number,
                size: 20 as number,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                isShowAnswer: false as boolean,
                answerInfo: {} as any,
            });

            onMounted(() => {
                state.idx = props.idx;
                state.data = props.data;

                document.body.style.overflow = "hidden";

                if (props.idx === state.eventIdx) getApplyListForCampainEvent();
                else {
                    getFormList();
                    getApplyList();
                }
            });

            onUnmounted(() => {
                document.body.style.overflow = "";
            });

            const closeModal = () => {
                emit("close");
            };

            const getFormList = async () => {
                state.formList = [];

                const res = await apiService.boardEvent.formList(state.idx);
                if (res.returnCode === 0) {
                    state.formList = res.data;
                } else {
                    console.error(res.description);
                    state.formList = [];
                }
            };

            const getApplyList = async () => {
                const param: types.ReqBoardApplyList = {
                    page: state.applyPage,
                    size: state.size,
                    searchType: null,
                    searchText: null,
                };

                const res = await apiService.boardEvent.applyList(state.idx, param);
                if (res && res.returnCode === 0) {
                    state.applyList = res.list.data;
                    state.cntApply = res.list.recordsTotal;
                }
            };

            const getApplyListForCampainEvent = async () => {
                const param: types.ReqBoardApplyList = {
                    page: state.applyPage,
                    size: state.size,
                    searchType: null,
                    searchText: null,
                };

                const res = await apiService.campainEvent.applyList(state.idx, param);
                if (res && res.returnCode === 0) {
                    state.applyList = res.list.data.map((item: any) => {
                        return {
                            ...item,
                            step1: item.step1.split(",").map((v: string) => Number(v)),
                            step2: item.step2.split(",").map((v: string) => Number(v)),
                            step3: item.step3.split(",").map((v: string) => Number(v)),
                        };
                    });
                    state.cntApply = res.list.recordsTotal;
                }
            };

            const save = () => {
                emit("save", state.data.memo);
            };

            const downloadFile = async (isPick: boolean) => {
                try {
                    let res = null;

                    if (state.eventIdx !== props.idx) res = await apiService.boardEvent.exportExcelForEvent(!isPick ? 0 : 1, state.idx);
                    else res = await apiService.campainEvent.exportExcel(state.eventIdx);

                    if (res && res.data) {
                        const blob = new Blob([res.data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });
                        const disposition = res.headers["content-disposition"];
                        let fileName = "download.xlsx";
                        if (disposition) {
                            const match = disposition.match(/filename="?(.+)"?/);
                            if (match && match[1]) {
                                fileName = decodeURIComponent(match[1]);
                            }
                        }
                        const a = document.createElement("a");
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("파일 다운로드 실패:", err);
                }
            };

            const showAnswer = (item: any) => {
                state.answerInfo = item;
                state.answerInfo.name = item.name;
                state.isShowAnswer = true;
            };

            const applyPaging = (page: number) => {
                state.applyPage = page;
                if (props.idx === state.eventIdx) getApplyListForCampainEvent();
                else getApplyList();
            };

            const answerFormat = (question: types.ResFormListVOForApi) => {
                let answer = "";
                if (question.type === 3) {
                    answer = question.answer;
                } else if (question.caseList && question.caseList.length > 0) {
                    answer += question.caseList
                        .map((caseItem) => {
                            if (caseItem.title === "기타") return `기타(${question.answer})`;
                            else return caseItem.title;
                        })
                        .join("\n");
                }

                return answer;
            };

            return { state, closeModal, props, CommonUtils, save, downloadFile, getApplyList, showAnswer, applyPaging, answerFormat };
        },
    };
</script>

<style scoped>
    .table_btn {
        color: #fff;
        font-weight: 500;
        background-color: var(--main_color);
        border-radius: 5px;
        font-size: 13px;
        padding: 0 5px;
    }

    .memo_wrap .cntWin_memo {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
    .memo_wrap .cntWin_memo > div {
        display: flex;
        flex-direction: row;
        gap: 10px;
    }
    .memo_wrap .cntWin_memo > div label {
        min-width: 60px;
    }

    .memo_wrap .cntWin_memo > div input[type="number"] {
        font-family: sans-serif;
        border: 1px solid #d6d6d6;
        border-radius: 5px;
        padding: 2px 10px;
        font-size: 15px;
    }

    .pop_up.applicant_chk {
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .list_container > div {
        flex: 1;
        width: 100%;
    }

    .table_wrap {
        width: 100%;
        max-height: 300px;
        overflow: auto;
    }
    .table_wrap table th {
        position: sticky;
        top: 0;
        z-index: 1;
        color: #6d6d6d;
        background-color: #eaf1ff;
        padding: 15px;
        font-size: 15px;
    }
    .table_wrap table td {
        text-align: center;
        vertical-align: middle;
        border-block: 1px solid #c4c4c4;
        padding: 5px;
        font-size: 15px;
    }
</style>
